module.exports = __webpack_public_path__ + "images/d3c814d20bc1b4ed5d1b503e64efacaa.svg";